import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UserModelService {

  private _loginChanged = new Subject<boolean>();

  public get loginChanged$() {
    return this._loginChanged.asObservable();
  }

  private _userProfileChanged = new Subject<void>();

  public get userProfileChanged$() {
    return this._userProfileChanged.asObservable();
  }

  private _articleNumberMappingsChanged = new Subject<void>();

  public get articleNumberMappingsChanged$() {
    return this._articleNumberMappingsChanged.asObservable();
  }

  private _selectedArticleNumberTypeChanged = new Subject<void>();

  public get selectedArticleNumberTypeChanged$() {
    return this._selectedArticleNumberTypeChanged.asObservable();
  }

  public notifySelectedArticleNumberTypeChanged(): void {
    this._selectedArticleNumberTypeChanged.next();
  }

  public notifyArticleNumberMappingsChanged(): void {
    this._articleNumberMappingsChanged.next();
  }

  public notifyUserProfileChanged(): void {
    this._userProfileChanged.next();
  }

  public notifyLoginChanged(success: boolean) {
    this._loginChanged.next(success);
  }

}
